import React, { 
    useEffect, 
    useContext,
} from "react"

import {
    Context,
    EMETLContext,
} from "../Model/Contexts/AppContext"

import {
    useAuthenticator,
} from "@aws-amplify/ui-react"

import "./Stylesheets/Dashboard.css"

import EMETLAssessmentManager from "../Model/EMETLAssessment.m"
import EMETLNavigator from "./Components/EMETLNavigator"
import EMETLFooter from "./Components/EMETLFooter"
import DashboardVM from "../ViewModel/Dashboard.vm"

/**
 * This component will represent the dashboard view, which renders all other views in this folder.
 *
 * @param props
 * @since   1.0.0
 * @exports Dashboard
 * @class
 */
const Dashboard = () => {
    const {
        user,
    } = useAuthenticator()

    EMETLAssessmentManager.ctx = useContext(Context) as EMETLContext

    const {
        amplify,
        assessmentData,
        loading: {
            value: isLoading,
            setMessage,
        },
    } = EMETLAssessmentManager.ctx
    
    const load = async () => {
        setMessage("Loading assessment data for user")
        const resp = await EMETLAssessmentManager.loadAssessmentData()
        if (!!resp?.length) 
            assessmentData.assessments.update(resp)
    }

    const handleSubscriptionUpdate = async (u) => {
        const {
            data,
            errors,
        } = u

        if (errors && !!errors?.length) {
            console.error(errors)

            return
        }

        const newAssessmentData = data?.onCreateAssessment

        if (newAssessmentData) {
            const newAssessmentsListed = await EMETLAssessmentManager.loadAssessmentData()
            if (!!newAssessmentsListed?.length && newAssessmentsListed?.length !== assessmentData?.assessments?.value?.length) {
                assessmentData.assessments.update(newAssessmentsListed)
            }
        }
    }

    const _init = async () => {
        DashboardVM.user = user
        DashboardVM.db = amplify 
        EMETLAssessmentManager.subscribe(handleSubscriptionUpdate)
        
        await load()
    }

    useEffect(() => {
        if (user && !!Object.keys(user)?.length) _init()

        return () => {
            EMETLAssessmentManager.unsubscribe()
        }
    }, [
        user, 
        amplify, 
    ])

    return (
        <div 
            id="dashboard"
        >
            {isLoading ? (
                <></>
            ) : (
                <>
                    <EMETLNavigator />
                    <EMETLFooter />
                </>
            )}
        </div>
    )
}

export default Dashboard
